export default {
  namespaced: true,
  state: {
    order: null,
  },
  getters: {
    order: state => state.order,
  },
  mutations: {
    UPDATE_ORDER(state, payload) {
      state.order = payload
    },
  },
  actions: {},
}
